module.exports = __webpack_public_path__ + "static/media/1022885.e1b259d6.jpg";